import { useState } from 'react';
import { IFarmResource } from '../../entities/farms.entities';
import FarmStatusModal from '../farm-modals/FarmStatusModal';
import { Button } from '../shared';
import { useSelector } from 'react-redux';
import { selectLang } from '../../store/ui/ui.selector';
import { translate } from '../../lib/lang.helper';

interface Props {
  farm: IFarmResource;
}

const FarmStatusButton = ({ farm }: Props) => {
  const lang = useSelector(selectLang);
  const [visible, setVisible] = useState(false);

  const handleClick = (event: any) => {
    event.stopPropagation();
    event.preventDefault();
    setVisible(true);
  };

  return (
    <div className='mt-8' onClick={e => e.stopPropagation()}>
      <Button
        width='small'
        size={0}
        type='fill'
        color={farm.is_closed ? 'red' : 'blue'}
        onClick={handleClick}
      >
        {translate(lang, farm.is_closed ? 'Closed' : 'Open')}
      </Button>
      {visible && (
        <FarmStatusModal farm={farm} onClose={() => setVisible(false)} />
      )}
    </div>
  );
};

export default FarmStatusButton;
